function sortDealersWithDirections(dealerList){
    dealerList.sort((a, b) => {
        if (a.Distance.value < b.Distance.value) {
            return -1;
        }
        if (a.Distance.value > b.Distance.value) {
            return 1;
        }
        return 0;
    });

    return dealerList;
}

function getClosestDealers(dealers, userLocation){
    let closestDealers = [];
    if (dealers == null) {
        return closestDealers;
    }
    dealers.forEach(dealer => {
        let distanceToDealer = getShortestDistanceToDealer(dealer, userLocation);
        if (distanceToDealer < 100000) {
            closestDealers.push(dealer);
        }
    });
    closestDealers.sort((a, b) => {
        if (a.directDistance < b.directDistance) {
            return -1;
        }
        if (a.directDistance > b.directDistance) {
            return 1;
        }
        return 0;
    });
    return closestDealers;
}

function getShortestDistanceToDealer(dealer, userLocation) {
    var dealerLatLng = new google.maps.LatLng(dealer.Lat, dealer.Long);
    var distance = google.maps.geometry.spherical.computeDistanceBetween(userLocation,
        dealerLatLng);
    dealer.directDistance = distance;
    return dealer.directDistance;
}

export { getClosestDealers, sortDealersWithDirections };